/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 쿠폰 사용 기간의 종류
 */
export type DurationType = 'Day' | 'Week' | 'Month' | 'Year';

export const DurationType = {
    Day: 'Day' as DurationType,
    Week: 'Week' as DurationType,
    Month: 'Month' as DurationType,
    Year: 'Year' as DurationType
};

